<template>
    <div>
        <!-- Start Footer Area  -->
        <footer v-if="data.showFooter" class="rn-footer footer-style-default variation-two">
            <div v-if="data.showCta" id="contact" name="contact" class="foot-up">
                <div class="foot-up-wrap center70 clearF">
									<div class="foot-contact">
										<h2>联系我们</h2>
										<div class="contact-items">
											<div>
												<div class="contact-item">
													<div class="contact-item-title">
														紧急联络
													</div>
													<div class="contact-item-content">
														<p>邮箱：service@isafeclub.org</p>
													</div>
												</div>
												<div class="contact-item">
													<div class="contact-item-title">
														办公室
													</div>
													<div class="contact-item-content">
														<p>新加坡（亚太总部）</p>
														<p>苏黎世（欧洲合规事务）</p>
														<p>纽约（北美政策联络）</p>
													</div>
												</div>
											</div>
											<div class="contact-item">
												<div class="contact-item-title">
													社交媒体
												</div>
												<div class="contact-item-content">
													<p>telegram技术讨论群组（会员专属）</p>
													<p>Twitter官方账号每日安全提醒</p>
												</div>

												<div class="foot-legal">
													<div class="foot-legal-wrap">
														<div class="legal-links">
															<a href="#" @click.prevent="openModal('terms')">《服务条款》</a>
															<span class="divider">|</span>
															<a href="#" @click.prevent="openModal('privacy')">《隐私政策》</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
            </div>
        </footer>

        <Copyright v-if="data.showCopyright"/>

        <ScrollTop/>

        <!-- Start Legal Modal -->
        <div v-if="activeModal" class="legal-modal" @click.self="closeModal">
            <div class="legal-modal-inner">
                <div class="legal-modal-head">
                    <h2>{{ activeModal === 'terms' ? '服务条款' : '隐私政策' }}</h2>
                    <button class="legal-modal-close" @click="closeModal">
                        <Icon name="x" size="22"/>
                    </button>
                </div>
                <div class="legal-modal-body">
                    <ul v-if="activeModal === 'terms'">
                        <li>网站服务使用规则：注册、会员准入、技术工具使用权限、线上研讨会参与规则；</li>
                        <li>用户权利与平台义务：服务交付标准、技术支持时效、项目交付周期约定；</li>
                        <li>付费服务规则：订阅续费、项目款项支付、退款 / 终止服务条件；</li>
                        <li>会员专属权益与限制；</li>
                        <li>安全工具、硬件软件使用许可协议；</li>
                        <li>用户内容、链上数据、漏洞报告知识产权归属；</li>
                        <li>责任限制：Web3 行业固有风险免责、黑客损失责任划分、第三方链 / 交易所风险隔离；</li>
                        <li>第三方服务说明：Telegram 社群、Twitter 账号、第三方支付、链上节点服务商权责划分；</li>
                        <li>服务变更、条款更新通知机制；</li>
                        <li>适用法律与争议解决：新加坡商事法律管辖，争议调解机构。</li>
                    </ul>
                    <ul v-else>
                        <li>收集用户数据范围：注册企业信息、联系人信息、链上项目资料、设备 IP、访问日志；</li>
                        <li>Cookies、本地存储使用规则，用户关闭 Cookie 操作指引；</li>
                        <li>数据存储、跨境传输规则（适配新加坡、欧美多区域办公室合规）；</li>
                        <li>数据使用目的：会员服务、安全项目交付、风险预警、产品推送；</li>
                        <li>第三方数据共享边界：仅合规监管机构法定调取，不向商业第三方出售用户数据；</li>
                        <li>用户数据权利：查阅、更正、删除、注销账户申请流程；</li>
                        <li>数据安全防护措施：加密存储、访问权限管控；</li>
                        <li>未成年人使用限制；</li>
                        <li>隐私政策修订公示渠道。</li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- End Legal Modal -->
    </div>
</template>

<script>
    import Copyright from './Copyright'
    import Button from '../../elements/button/Button'
    import Icon from '../../icon/Icon'
    import ScrollTop from './ScrollTop'
    import Logo from '../../elements/logo/Logo'
    import Newsletter from './Newsletter'

    export default {
        name: 'Footer',
        components: {Newsletter, Logo, ScrollTop, Icon, Button, Copyright},
        props: {
            data: {
                default: null
            }
        },
        data() {
            return {
                activeModal: null
            }
        },
        methods: {
            openModal(type) {
                this.activeModal = type;
                document.body.style.overflow = 'hidden';
            },
            closeModal() {
                this.activeModal = null;
                document.body.style.overflow = '';
            }
        }
    }
</script>
<style lang="scss">
.foot-up {
	padding: 40px 0;
	background-color: #070a2b;
	.foot-up-wrap {
		display: flex;
		align-items: center;
		.foot-contact {
			width: 100%;
			h2 {
				font-size: 18px;
				padding-bottom: 16px;
				margin-bottom: 20px;
				color: white;
				position: relative;
				&:after {
					content: "";
					position: absolute;
					bottom: 0;
					left: 0;
					width: 50px;
					height: 3px;
					background-color: #fff;
				}
			}
			.contact-items {
				display: flex;
				justify-content: space-between;
				width: 100%;
			}
			.contact-item {
				color: #b6b7b7;
				.contact-item-title {
					font-weight: 400;
					font-size: 20px;
				}
				.contact-item-content {
					margin-top: 12px;
					font-size: 14px;
					display: flex;
					gap: 20px;
					p {
						color: #b6b7b7;
					}
				}
			}
		}
	}
}
.foot-legal {
	padding: 30px 0;
	.foot-legal-wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 30px;
	}
	.legal-statement {
		flex: 1;
		h3 {
			font-size: 16px;
			color: #fff;
			margin-bottom: 10px;
		}
		p {
			font-size: 13px;
			color: #8f91a8;
			line-height: 1.8;
			margin-bottom: 0;
		}
	}
	.legal-links {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		gap: 10px;
		a {
			color: #b6b7b7;
			font-size: 14px;
			transition: .3s;
			&:hover {
				color: #0d6efd;
			}
		}
		.divider {
			color: #444;
		}
	}
}
.legal-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, .6);
	z-index: 9999;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	.legal-modal-inner {
		background: #fff;
		width: 100%;
		max-width: 760px;
		max-height: 80vh;
		border-radius: 12px;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		animation: legalModalIn .3s ease;
	}
	.legal-modal-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 30px;
		background: #070a2b;
		h2 {
			font-size: 22px;
			color: #fff;
			margin: 0;
		}
		.legal-modal-close {
			background: none;
			border: none;
			color: #fff;
			cursor: pointer;
			display: flex;
			padding: 0;
		}
	}
	.legal-modal-body {
		padding: 30px;
		overflow-y: auto;
		ul {
			padding-left: 0;
			margin: 0;
			li {
				font-size: 15px;
				color: #4d4d4d;
				line-height: 1.7;
				padding: 12px 0 12px 24px;
				position: relative;
				border-bottom: 1px dashed #eee;
				&:last-child {
					border-bottom: none;
				}
				&:before {
					content: "";
					position: absolute;
					left: 4px;
					top: 20px;
					width: 8px;
					height: 8px;
					border-radius: 50%;
					background-color: #0d6efd;
				}
			}
		}
	}
}
@keyframes legalModalIn {
	from { opacity: 0; transform: translateY(30px); }
	to { opacity: 1; transform: translateY(0); }
}
@media screen and (max-width: 850px) {
	.foot-up .foot-up-wrap .foot-contact .contact-items,
	.foot-up .foot-up-wrap .foot-contact .contact-item .contact-item-content{
		flex-direction: column;
	}
	p {
		margin-bottom: 0 !important;
	}
	.contact-item:last-child {
		margin-top: 20px;
	}
	.foot-legal .foot-legal-wrap {
		flex-direction: column;
		align-items: flex-start;
	}
}
</style>
